const colors = {
  white: "#FFFFFF",
  black: "#131737",
  teal: {
    50: "#D3EDF0",
    100: "#B9E2E7",
    200: "#9FD7DE",
    300: "#85CCD5",
    400: "#6BC1CB",
    500: "#51B6C2",
    600: "#3398a4",
    700: "#2A8D98",
    800: "#1C747F",
    900: "#105A62",
  },
  violet: "#8676FF",
  purpleGradient: "#8D188B",
  blueGradient: "#39BBFA",
  lightBlue: {
    400: "#daf9fd",
    500: "#caedf9",
  },
  bg: "#fcfcfa",
  textGrey: "#A1A1A6",
  textGreyDark: "#686868",
  cyan: {
    550: "#51B6C2",
  },
  test: "#E7E1D8",
  lightGray: {
    50: "#FFFEFE",
    100: "#FDFCFB",
    200: "#FBFAF8",
    300: "#F9F8F5",
    400: "#F7F5F2",
    500: "#F5F3EF",
    550: "#E7E1D8",
    600: "#D0CFCB",
    700: "#ACAAA7",
    800: "#878683",
    900: "#626160",
  },
  gray: {
    550: "#828282",
  },
  brightOrange: {
    100: "#FBF0ED",
    200: "#F4CEC2",
    300: "#F2A993",
    400: "#F38260",
    500: "#F95928",
    550: "#D24316",
    600: "#A63008",
    700: "#A63008",
    800: "#792000",
    900: "#4D1200",
  },
  brightGreen: "#05bf8e",
} as const;

const colorTokens = {
  primary: {
    contrast: colors.white,
    fg: colors.teal["500"],
    subtle: colors.teal["50"],
    muted: colors.teal["200"],
    emphasized: colors.teal["300"],
    solid: colors.teal["400"],
    shadow: colors.teal["800"],
    focus: colors.teal["600"],
  },
  secondary: {
    contrast: colors.black,
    fg: colors.white,
    subtle: colors.lightGray["100"],
    muted: colors.lightGray["200"],
    emphasized: colors.lightGray["300"],
    solid: colors.lightGray["400"],
    focus: colors.lightGray["500"],
    shadow: colors.lightGray["600"],
  },
  tertiary: {
    contrast: colors.black,
    fg: colors.lightGray["500"],
    subtle: colors.lightGray["100"],
    muted: colors.lightGray["200"],
    emphasized: colors.lightGray["300"],
    solid: colors.lightGray["400"],
    focus: colors.lightGray["600"],
    shadow: colors.lightGray["800"],
  },
  alert: {
    contrast: colors.white,
    fg: colors.brightOrange["500"],
    subtle: colors.brightOrange["100"],
    muted: colors.brightOrange["200"],
    emphasized: colors.brightOrange["300"],
    solid: colors.brightOrange["400"],
    shadow: colors.brightOrange["800"],
  },
  success: colors.brightGreen,
}

export default { ...colors, ...colorTokens }
